import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailExcursion} from '../interfaces/icruise-detail-excursion';
import {MappingItem} from '../../../../shared/interfaces/mapping-item';
import uniqBy from '../../../../../utils/uniqBy';

@Pipe({
  name: 'excursionPorts'
})
export class ExcursionPortsPipe implements PipeTransform {

  transform(value: ICruiseDetailExcursion[]): MappingItem[] {
    return value ? uniqBy(value.map(e => e.harbour), 'code') : [];
  }

}
